/* NAYOORA — consolidated custom JS (gift bar, recently viewed, wishlist, complete-the-look, 7-day safety net). Loaded deferred for speed. */

/* ---- 1. Global text safety net: enforce 7-day returns wording ---- */
(function(){
  function fix(){
    if(!document.body)return;
    var rx=[[/\b2\s*-?\s*days?\s+easy\s+returns/gi,'7-Day Easy Returns'],
            [/\bwithin\s+2\s+days\b/gi,'within 7 days'],
            [/\b2\s*-?\s*days?\s+returns?(\s*(?:&amp;|&|and)\s*exchanges?)?/gi,'7-Day Returns & Exchanges'],
            [/\b2\s*-?\s*day\s+return/gi,'7-Day Return']];
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,{acceptNode:function(n){var p=n.parentNode?n.parentNode.nodeName:'';if(p==='SCRIPT'||p==='STYLE'||p==='TEXTAREA'||p==='INPUT')return NodeFilter.FILTER_REJECT;return /2\s*-?\s*day/i.test(n.nodeValue)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;}});
    var nodes=[],n;while(n=w.nextNode())nodes.push(n);
    nodes.forEach(function(t){var v=t.nodeValue;rx.forEach(function(r){v=v.replace(r[0],r[1]);});if(v!==t.nodeValue)t.nodeValue=v;});
  }
  if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',fix);
  window.addEventListener('load',function(){
    fix();
    setTimeout(function(){if(window.__nayooraFixObserver){try{window.__nayooraFixObserver.disconnect();}catch(e){}}},15000);
  });
  if(window.MutationObserver){
    var mo=new MutationObserver(function(){if(fix._t)return;fix._t=setTimeout(function(){fix._t=null;fix();},400);});
    window.__nayooraFixObserver=mo;
    function startObs(){if(document.body)mo.observe(document.body,{childList:true,subtree:true,characterData:true});}
    if(document.body)startObs();else document.addEventListener('DOMContentLoaded',startObs);
  }
})();

/* ---- 1b. Shrink the trademark mark (™) everywhere so "Nayoora" stays the focus ---- */
(function(){
  var TM='\u2122';
  function wrap(root){
    if(!root)return;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      var p=n.parentNode?n.parentNode.nodeName:'';
      if(p==='SCRIPT'||p==='STYLE'||p==='TEXTAREA'||p==='TITLE')return NodeFilter.FILTER_REJECT;
      if(n.parentNode&&n.parentNode.classList&&n.parentNode.classList.contains('nytm'))return NodeFilter.FILTER_REJECT;
      return n.nodeValue.indexOf(TM)>-1?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;
    }});
    var nodes=[],n;while(n=w.nextNode())nodes.push(n);
    nodes.forEach(function(t){
      var parts=t.nodeValue.split(TM);
      if(parts.length<2)return;
      var frag=document.createDocumentFragment();
      parts.forEach(function(seg,i){
        if(i>0){var s=document.createElement('sup');s.className='nytm';s.textContent=TM;frag.appendChild(s);}
        if(seg)frag.appendChild(document.createTextNode(seg));
      });
      if(t.parentNode)t.parentNode.replaceChild(frag,t);
    });
  }
  function run(){wrap(document.body);}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  window.addEventListener('load',run);
  if(window.MutationObserver){var t;new MutationObserver(function(){if(t)return;t=setTimeout(function(){t=null;run();},250);}).observe(document.documentElement,{childList:true,subtree:true});}
})();

/* ---- 2. Cart free-gift progress bar ---- */
(function(){
  var TIERS=[{amt:149900,name:'Potli Bag'},{amt:649900,name:'Jewellery Set'},{amt:1099900,name:'Perfume Gift Set'}];
  var GIFTSVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"/></svg>';
  function inr(p){return '\u20b9'+Math.ceil(p/100).toLocaleString('en-IN');}
  function tpl(){return '<div class="nygift"><div class="nygift__top"><span class="nygift__gi">'+GIFTSVG+'</span><p class="nygift__msg"></p></div><div class="nygift__track"><div class="nygift__fill"></div></div><div class="nygift__tiers"></div></div>';}
  function compute(total){
    var ui=-1,ni=-1;
    for(var i=0;i<TIERS.length;i++){if(total>=TIERS[i].amt)ui=i;}
    for(var k=0;k<TIERS.length;k++){if(total<TIERS[k].amt){ni=k;break;}}
    var seg=100/TIERS.length,msg,pct,done=false;
    if(ni<0){msg='You\u2019ve unlocked our top reward \u2014 a FREE '+TIERS[TIERS.length-1].name;pct=100;done=true;}
    else if(ui<0){msg='Add <b>'+inr(TIERS[0].amt-total)+'</b> more to receive a FREE '+TIERS[0].name;pct=Math.max(3,Math.round((total/TIERS[0].amt)*seg));}
    else{var prev=TIERS[ui].amt;var within=(total-prev)/(TIERS[ni].amt-prev);msg='FREE '+TIERS[ui].name+' unlocked! Add <b>'+inr(TIERS[ni].amt-total)+'</b> more to upgrade to the '+TIERS[ni].name;pct=Math.max(3,Math.round((ni+within)*seg));}
    var t='';for(var j=0;j<TIERS.length;j++){t+='<span class="nygift__lb'+(j===ui?' cur':'')+'">'+TIERS[j].name+'</span>';}
    return {msg:msg,pct:pct,done:done,tiers:t};
  }
  function ensure(){
    ['.cart-drawer__items','.cart-page__items'].forEach(function(sel){
      var c=document.querySelector(sel);
      if(c&&!c.querySelector(':scope > .nygift')){var w=document.createElement('div');w.innerHTML=tpl();c.insertBefore(w.firstChild,c.firstChild);}
    });
  }
  function paint(total){
    var bars=document.querySelectorAll('.nygift');if(!bars.length)return;
    var c=compute(total);
    bars.forEach(function(b){
      b.querySelector('.nygift__msg').innerHTML=c.msg;
      b.querySelector('.nygift__fill').style.width=c.pct+'%';
      b.querySelector('.nygift__tiers').innerHTML=c.tiers;
      b.classList.toggle('nygift--done',c.done);
    });
  }
  var lastTotal=0;
  function sync(){ensure();paint(lastTotal);}
  function refresh(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){lastTotal=cart.total_price;sync();}).catch(function(){});}
  if(document.readyState!=='loading')refresh();else document.addEventListener('DOMContentLoaded',refresh);
  var of=window.fetch;
  window.fetch=function(){var a=arguments,u=(a[0]&&a[0].url)||a[0]||'';var p=of.apply(this,a);try{if(typeof u==='string'&&/\/cart\/(add|change|update|clear)/.test(u)){p.then(function(){setTimeout(refresh,300);});}}catch(e){}return p;};
  function watch(){if(!window.MutationObserver||!document.body)return;var mo=new MutationObserver(function(){var need=['.cart-drawer__items','.cart-page__items'].some(function(sel){var c=document.querySelector(sel);return c&&!c.querySelector(':scope > .nygift');});if(need&&!mo._t){mo._t=setTimeout(function(){mo._t=null;sync();},50);}});mo.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState!=='loading')watch();else document.addEventListener('DOMContentLoaded',watch);
})();

/* ---- 3. Recently Viewed ---- */
(function(){
  var KEY='ny_rv';
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a.slice(0,12)));}catch(e){}}
  var m=location.pathname.match(/\/products\/([^\/?#]+)/);
  if(m){var h=m[1];var cur=get().filter(function(x){return x!==h;});cur.unshift(h);save(cur);}
  if(!m)return;
  var handles=get().filter(function(x){return x!==m[1];}).slice(0,8);
  if(handles.length<2)return;
  function build(){
    if(document.getElementById('nyrv'))return;
    var sec=document.createElement('section');sec.id='nyrv';sec.className='nyrv';
    sec.innerHTML='<h2 class="nyrv__hd">Recently Viewed</h2><div class="nyrv__rail"></div>';
    var rec=document.querySelector('[id*="product_recommendations"]');
    if(rec&&rec.parentNode){rec.parentNode.insertBefore(sec,rec.nextSibling);}else{(document.querySelector('main')||document.body).appendChild(sec);}
    var rail=sec.querySelector('.nyrv__rail');
    handles.forEach(function(hh){
      fetch('/products/'+hh+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
        if(!p)return;
        var img=p.featured_image||(p.images&&p.images[0])||'';
        if(img&&img.indexOf('//')===0)img='https:'+img;
        if(img)img=img+(img.indexOf('?')>-1?'&':'?')+'width=300';
        var price='\u20b9'+Math.round(p.price/100).toLocaleString('en-IN');
        var title=(p.title||'').replace('Nayoora ','').replace('Luxe ','');
        var a=document.createElement('a');a.className='nyrv__card';a.href='/products/'+p.handle;
        a.innerHTML='<div class="nyrv__imgw">'+(img?'<img loading="lazy" src="'+img+'" alt="">':'')+'</div><div class="nyrv__t">'+title+'</div><div class="nyrv__p">'+price+'</div>';
        rail.appendChild(a);
      }).catch(function(){});
    });
  }
  if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();

/* ---- 4. Wishlist ---- */
(function(){
  var KEY='ny_wish';
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function store(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  function toggle(h){var a=get();var i=a.indexOf(h);if(i>-1)a.splice(i,1);else a.unshift(h);store(a);refresh();}
  function marks(){var a=get();document.querySelectorAll('.ny-wish').forEach(function(b){var on=a.indexOf(b.getAttribute('data-handle'))>-1;b.classList.toggle('ny-wish--on',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',on?'Remove from wishlist':'Save to wishlist');});}
  /* Move the heart INTO the product image so it always sits inside the card (like the badge) */
  function place(){document.querySelectorAll('.ny-wish').forEach(function(b){var card=b.closest&&b.closest('product-card, .product-card');if(!card)return;var gal=card.querySelector('.card-gallery');if(gal&&b.parentNode!==gal){gal.appendChild(b);}});}
  var fab,ov,dr;
  function chrome(){
    if(fab)return;
    fab=document.createElement('button');fab.id='nywl-fab';fab.innerHTML='<svg viewBox="0 0 24 24"><path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"/></svg> Wishlist <span class="nywl-count">0</span>';
    document.body.appendChild(fab);
    ov=document.createElement('div');ov.className='nywl-ov';document.body.appendChild(ov);
    dr=document.createElement('div');dr.className='nywl-dr';dr.innerHTML='<div class="nywl-dr__hd"><h3>My Wishlist</h3><button class="nywl-dr__x" aria-label="Close">\u00d7</button></div><div class="nywl-dr__body"></div>';document.body.appendChild(dr);
    fab.onclick=open;ov.onclick=close;dr.querySelector('.nywl-dr__x').onclick=close;
  }
  function open(){chrome();render();ov.classList.add('show');requestAnimationFrame(function(){dr.classList.add('show');});}
  function close(){dr.classList.remove('show');ov.classList.remove('show');}
  function render(){
    var body=dr.querySelector('.nywl-dr__body');var a=get();
    if(!a.length){body.innerHTML='<div class="nywl-empty">Your wishlist is empty.<br>Tap the heart on any product to save it here.</div>';return;}
    body.innerHTML='';
    a.forEach(function(h){
      fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
        if(!p)return;
        var img=p.featured_image||(p.images&&p.images[0])||'';if(img&&img.indexOf('//')===0)img='https:'+img;if(img)img=img+(img.indexOf('?')>-1?'&':'?')+'width=160';
        var price='\u20b9'+Math.round(p.price/100).toLocaleString('en-IN');
        var el=document.createElement('div');el.className='nywl-item';
        el.innerHTML='<img src="'+img+'" alt=""><div class="nywl-item__i"><a class="nywl-item__t" href="/products/'+p.handle+'">'+(p.title||'').replace('Nayoora ','')+'</a><div class="nywl-item__p">'+price+'</div><button class="nywl-item__rm" data-h="'+p.handle+'">Remove</button></div>';
        body.appendChild(el);
        el.querySelector('.nywl-item__rm').onclick=function(){toggle(p.handle);render();};
      }).catch(function(){});
    });
  }
  function refresh(){var n=get().length;chrome();fab.classList.toggle('show',n>0);fab.querySelector('.nywl-count').textContent=n;place();marks();}
  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('.ny-wish');if(b){e.preventDefault();e.stopPropagation();toggle(b.getAttribute('data-handle'));}},true);
  if(document.readyState!=='loading')refresh();else document.addEventListener('DOMContentLoaded',refresh);
  if(window.MutationObserver){var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){place();marks();},200);}).observe(document.documentElement,{childList:true,subtree:true});}
})();

/* ---- 5. Complete the Look ---- */
(function(){
  if(!/\/products\//.test(location.pathname))return;
  var handle=location.pathname.split('/products/')[1].split(/[?#]/)[0];
  if(!handle)return;
  function inr(p){return '\u20b9'+Math.round(p/100).toLocaleString('en-IN');}
  fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(cur){
    return fetch('/recommendations/products.json?product_id='+cur.id+'&intent=complementary&limit=4').then(function(r){return r.json();}).then(function(d){
      var recs=(d.products||[]).filter(function(p){return p.id!==cur.id&&p.available;}).slice(0,3);
      if(recs.length<2)return;
      build(recs);
    });
  }).catch(function(){});
  function build(recs){
    if(document.getElementById('nycl'))return;
    var sec=document.createElement('section');sec.id='nycl';sec.className='nycl';
    var items='';
    recs.forEach(function(p,i){
      var img=p.featured_image||(p.images&&p.images[0])||'';if(img&&img.indexOf('//')===0)img='https:'+img;if(img)img=img+(img.indexOf('?')>-1?'&':'?')+'width=300';
      var vid=(p.variants&&p.variants[0]&&p.variants[0].id)||'';
      items+='<label class="nycl__item"><input type="checkbox" class="nycl__cb" checked data-v="'+vid+'" data-price="'+p.price+'"><div class="nycl__img">'+(img?'<img src="'+img+'" alt="">':'')+'</div><div class="nycl__t">'+(p.title||'').replace('Nayoora ','')+'</div><div class="nycl__p">'+inr(p.price)+'</div></label>';
    });
    sec.innerHTML='<h2 class="nycl__hd">Complete the Look</h2><div class="nycl__items">'+items+'</div><button class="nycl__add" type="button"></button>';
    var rec=document.querySelector('[id*="product_recommendations"]');
    if(rec&&rec.parentNode){rec.parentNode.insertBefore(sec,rec);}else{(document.querySelector('main')||document.body).appendChild(sec);}
    var btn=sec.querySelector('.nycl__add');
    function upd(){
      var cbs=sec.querySelectorAll('.nycl__cb'),n=0,tot=0;
      cbs.forEach(function(c){c.closest('.nycl__item').classList.toggle('off',!c.checked);if(c.checked){n++;tot+=parseInt(c.getAttribute('data-price'),10)||0;}});
      btn.disabled=n===0;btn.textContent=n?('Add '+n+' to Cart \u00b7 '+inr(tot)):'Select items';
    }
    sec.addEventListener('change',upd);upd();
    btn.addEventListener('click',function(){
      var items=[];sec.querySelectorAll('.nycl__cb').forEach(function(c){if(c.checked&&c.getAttribute('data-v'))items.push({id:parseInt(c.getAttribute('data-v'),10),quantity:1});});
      if(!items.length)return;btn.disabled=true;btn.textContent='Adding\u2026';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}).then(function(r){return r.json();}).then(function(){
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var t=document.querySelector('.cart-drawer-trigger,[href="/cart"],cart-drawer-trigger');if(t&&t.click){t.click();}else{location.href='/cart';}
      }).catch(function(){location.href='/cart';});
    });
  }
})();
